import { render, staticRenderFns } from "./PostAnalytics.vue?vue&type=template&id=378c2572&scoped=true"
import script from "./PostAnalytics.vue?vue&type=script&lang=js"
export * from "./PostAnalytics.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "378c2572",
  null
  
)

export default component.exports